import { classNames } from 'libs/react';
import { Icon } from 'components/Icon';
import { Link } from 'components/Link';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './Button.scss';
/**
 * @component Button
 * @since 1.0.0
 */
export function Button(props) {
    const { route, size, style, noPadding, picto, badge, label, form, submit, selected, disabled, processing, stopPropagation } = Object.assign({ size: 'medium', style: 'normal', selected: false, disabled: false }, props);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick(e) {
        if (stopPropagation) {
            e.stopPropagation();
        }
        if (disabled) {
            return;
        }
        if (props.onPress) {
            props.onPress();
        }
        if (typeof submit == 'string') {
            const form = document.getElementsByName(submit);
            if (form instanceof HTMLFormElement) {
                form.submit();
            }
        }
    }
    const className = classNames('button', 'button--' + size, 'button--' + style, { 'button--is-selected': selected }, { 'button--is-disabled': disabled }, { 'button--is-processing': processing }, { 'button--has-label': label }, { 'button--has-picto': picto }, { 'button--has-badge': badge }, { 'button--no-padding': noPadding }, props.className);
    if (route) {
        return (React.createElement(Link, { className: className, route: route, "aria-disabled": disabled || undefined },
            picto && React.createElement(Icon, { className: "button-picto", value: picto }),
            label && React.createElement(Text, { className: "button-label", value: label }),
            badge && React.createElement(Icon, { className: "button-badge", value: badge })));
    }
    return (React.createElement("button", { form: form, className: className, type: submit ? 'submit' : 'button', disabled: disabled, onClick: onClick, "data-form": submit, "aria-label": props.ariaLabel, "aria-pressed": props.ariaPressed },
        picto && React.createElement(Icon, { className: "button-picto", value: picto }),
        label && React.createElement(Text, { className: "button-label", value: label }),
        badge && React.createElement(Icon, { className: "button-badge", value: badge })));
}
